import React from 'react';
import Modal from "react-bootstrap/Modal";

const VisibilityBestClipPopup = ({ showVisibilityBestClipPopup, setShowVisibilityBestClipPopup }) => {

  return (
    <>
      <section className='visibilityBestClipPopups'>
        <Modal show={showVisibilityBestClipPopup} onHide={() => setShowVisibilityBestClipPopup(false)} size="sm" centered backdrop="static" keyboard={false} className="main-modal" >
          <Modal.Header closeButton>&nbsp;</Modal.Header>
          <Modal.Body className="popupModal-body">
            <section className='visibilityBestClipPopup'>
              <form className='visibilityBestClipPopup-form'>
                <input type="radio" id="following" name="visibility" />
                <label htmlFor="following">Following</label> 

                <input type="radio" id="everyone" name="visibility" />
                <label htmlFor="everyone">Everyone</label>
              </form>
            </section>
          </Modal.Body>
        </Modal>
      </section> 
    </>
  )
}

export default VisibilityBestClipPopup
